import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { RentalApplicationService } from 'src/app/services/rental-application.service';
import { RentalService } from 'src/app/services/rental.service';
import { switchMap } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-application-print',
  templateUrl: './application-print.component.html',
  imports: [CommonModule],
  styleUrls: ['./application-print.component.scss']
})
export class ApplicationPrintComponent implements OnInit {

  application: any;
  rental: any;

  constructor(
    private route: ActivatedRoute,
    private applicationService: RentalApplicationService,
    private rentalService: RentalService
  ) {}

  ngOnInit(): void {

    const roundId = this.route.snapshot.paramMap.get('roundId')!;
    const applicationId = this.route.snapshot.paramMap.get('applicationId')!;

    this.applicationService
      .getApplicationById(roundId, applicationId)
      .pipe(
        switchMap(app => {
          this.application = app;
          return this.rentalService.getRentalById(app.rentalId);
        })
      )
      .subscribe(rental => {
        this.rental = rental;

        setTimeout(() => {
          window.print();
        }, 500);
      });
  }

  getTotalIncome(): number {
    return Number(this.application?.income || 0) +
           Number(this.application?.coIncome || 0);
  }
}
